<style lang="scss">
    .product-comparision__row {
        width: auto;
    }

    /*Mobile adjustements*/
    @media only screen and (max-width: 767px) {

        .product-comparision {

            .parametric-intro {
                padding-top: 0;
                margin: 0 !important;
            }
        }

        .product-comparision {

            .page-title {
                padding: 15px 0 !important;
            }
        }

        .product-comparision__content {
            margin-bottom: 36px;
            width: calc(100% + 15px);
        }
    }

    /*Tablet adjustements*/
    @media only screen and (max-width: 992px) {

        .product-comparision__content {
            overflow-x: auto !important;
        }
    }

    thead.product-comparision__thead tr:nth-child(2) th {
        border-top: 1px solid #ddd;
    }

    .table-actions {
        vertical-align: top;
    }

    table.product-comparision__table {
        border: 0;
    }

    table.product-comparision__table thead tr:first-child .product-comparison-headers {
        position: relative;
        vertical-align: top;

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 23px;
            height: 2px;
            background: #ddd;
            width: 100%;
        }
    }

    table.product-comparision__table thead tr:first-child .product-comparison-headers:last-child:after {
        width: calc(100% - 23px);
    }

    table.product-comparision__table thead tr:not(:first-child) th:first-child,
    table.product-comparision__table tbody tr td:first-child {
        border-left: 1px solid #ddd;
    }

    table.product-comparision__table thead tr:not(:first-child) th:last-child,
    table.product-comparision__table tbody tr td:last-child {
        border-right: 1px solid #ddd;
    }

    table.product-comparision__table tbody tr:last-child td {
        border-bottom: 1px solid #ddd;
    }

    .product-comparision .btn-default {
        width: 100%;
    }

    .product-comparision__btn-group .button-special {
        width: 130px;

        &:hover {
            border: none !important;
        }
    }

    .product-comparision__list {
        padding: 0 10px 10px 2px;
        margin-bottom: 50px;
    }

    .product-comparision__list-item--main {
        padding: 0 10px 10px 23px !important;
        border-bottom: none !important;
        margin-bottom: 15px !important;
    }

    .product-comparision__list {
        padding-top: 20px;
    }

    .parametric-intro {
        width: auto !important;
    }

    .product-comparision__cell--bold {
        font-weight: 600;
        color: #000;
    }

    .product-comparision__table-row--bordered {
        border-top: 1px solid #ddd;
        border-right: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .product-comparision__btn-group .button-special .btn {
        text-align: left;
        border-radius: 0;
        font-weight: 400;
    }

    .product-comparision__select {
        max-width: 195px;
    }

    .product-comparision__th:not(.product-comparision__cell--bold) {
        min-width: 249px;
    }

    .product-comparison-headers {
        vertical-align: top;
    }
    .product-comparision__table{
        margin-bottom: 25px;
    }
    .custom-class {
        padding-left: 25px;
    }

    .myAmpleon .parametric-intro {
        padding-top: 25px;
    }
</style>

<template>
    <div class="product-comparision">
        <div class="parametric-intro">
            <h3 class="page-title">Demo Board</h3>
        </div>

        <div class="product-comparision__content">
            <div class="product-comparision__row">
                <table class="product-comparision__table">
                    <thead class="product-comparision__thead">
                    <tr class="product-comparision__table-row">
                        <th class="table-actions" rowspan="2">
                            <div class="product-comparision__btn-group">
                                <div class="button-special">
                                    <a class="btn btn-default" id="save-excel" @click="downloadDemoBoardExcel"
                                       role="button"><i class="lnr lnr-enter-down"></i> save to excel</a>
                                </div>
                                <div class="button-special">
                                    <router-link class="btn btn-default" :to="{path: isPublic ?  '/' : '/my-parametric-search'}"><i
                                            class="lnr lnr-undo"></i> go back
                                    </router-link>
                                </div>
                            </div>
                        </th>
                        <template v-if="isDemoFetchingSuccess">
                            <th class="product-comparison-headers"
                                v-for="(product, index) in convertedDemoBoardItems.typeNumber">
                                <div class="product-comparision__list-item product-comparision__list-item--main">
                                    <a :href="convertedDemoBoardItems.productDetailsLink[index]"
                                       class="product-comparision__list-anchor">{{product}}</a>
                                    <span class="product-comparision__list-subitem">{{convertedDemoBoardItems.description[index]}}</span>
                                </div>
                            </th>
                        </template>
                        <template v-else-if="!isDemoLoading && isDemoFetchingFailed">
                            <th>
                                <div class="product-comparision__list-item product-comparision__list-item--main">
                                    Internal error.
                                </div>
                            </th>
                        </template>
                    </tr>
                    <tr v-if="isDemoFetchingSuccess" class="product-comparision__table-row">
                        <td class="product-comparison-headers custom-class"
                            v-for="(product, index) in convertedDemoBoardItems.typeNumber">
                            <ul class="product-comparision__list">
                                <li class="product-comparision__list-item">
                                    <a :href="convertedDemoBoardItems.productDetailsLink[index]"
                                       class="product-comparision__list-anchor">Product Details</a>
                                </li>

                                <li class="product-comparision__list-item">
                                    <a :href="convertedDemoBoardItems.dataSheetLink[index]"
                                       class="product-comparision__list-anchor">Datasheet</a>
                                </li>
                                <li class="product-comparision__list-item">
                                    <a :href="convertedDemoBoardItems.productDetailsLink[index] + '#ordering'"
                                       class="product-comparision__list-anchor">Sample / Buy</a>
                                </li>
                                <li class="product-comparision__list-item">
                                    <a :href="convertedDemoBoardItems.productDetailsLink[index] + '#documentation'"
                                       class="product-comparision__list-anchor">Documentation</a>
                                </li>
                                <li class="product-comparision__list-item">
                                    <a :href="convertedDemoBoardItems.productDetailsLink[index] + '#designsupportdocs'"
                                       class="product-comparision__list-anchor">Design Support</a>
                                </li>
                            </ul>
                        </td>
                    </tr>
                    </thead>
                    <tbody v-if="isDemoFetchingSuccess" class="product-comparision__tbody">
                    <tr class="product-comparision__table-row--bordered">
                        <th class="product-comparision__th product-comparision__cell--bold first-column">Application</th>
                        <th v-for="product in convertedDemoBoardItems.application"
                            class="product-comparision__th">{{product}}
                        </th>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">Demo Report</td>
                        <td v-for="(product, index) in convertedDemoBoardItems.demoReport"
                            class="product-comparision__th">
                            <a :href="convertedDemoBoardItems.demoReportLink[index]">{{product}}</a></td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">F<sub>min</sub> (MHz)
                        </td>
                        <td v-for="product in convertedDemoBoardItems.frangeMin" class="product-comparision__th">
                            {{product}}
                        </td>

                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">F<sub>max</sub> (MHz)
                        </td>
                        <td v-for="product in convertedDemoBoardItems.frangeMax" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">P<sub>L(AV)</sub> (W)
                        </td>
                        <td v-for="product in convertedDemoBoardItems.plav" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">P<sub>L(AV)</sub> (dBm)
                        </td>
                        <td v-for="product in convertedDemoBoardItems.plavdBdBm" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">P<sub>L(1dB)</sub> (W)
                        </td>
                        <td v-for="product in convertedDemoBoardItems.pl1dB" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">P<sub>L(1dB)</sub> (dBm)
                        </td>
                        <td v-for="product in convertedDemoBoardItems.pl1dBdBm" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">P<sub>L(3dB)</sub> (W)
                        </td>
                        <td v-for="product in convertedDemoBoardItems.pl3dB" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">P<sub>L(3dB)</sub> (dBm)
                        </td>
                        <td v-for="product in convertedDemoBoardItems.pl3dBdBm" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                      <td class="product-comparision__th product-comparision__cell--bold">P<sub>L(4dB)</sub> (W)
                      </td>
                      <td v-for="product in convertedDemoBoardItems.pl4dB" class="product-comparision__th">
                        {{product}}
                      </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                      <td class="product-comparision__th product-comparision__cell--bold">P<sub>L(4dB)</sub> (dBm)
                      </td>
                      <td v-for="product in convertedDemoBoardItems.pl4dBdBm" class="product-comparision__th">
                        {{product}}
                      </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                      <td class="product-comparision__th product-comparision__cell--bold">P<sub>L(5dB)</sub> (W)
                      </td>
                      <td v-for="product in convertedDemoBoardItems.pl5dB" class="product-comparision__th">
                        {{product}}
                      </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                      <td class="product-comparision__th product-comparision__cell--bold">P<sub>L(5dB)</sub> (dBm)
                      </td>
                      <td v-for="product in convertedDemoBoardItems.pl5dBdBm" class="product-comparision__th">
                        {{product}}
                      </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">η<sub>D</sub> (%)</td>
                        <td v-for="product in convertedDemoBoardItems.nd" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    <tr class="product-comparision__table-row">
                        <td class="product-comparision__th product-comparision__cell--bold">Demo Signal</td>
                        <td v-for="product in convertedDemoBoardItems.demoSignal" class="product-comparision__th">
                            {{product}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import { ParametricSearchService } from "../../common/api.service";
    import { downloadFile, mimeTypes } from "../../common/download.service";

    export default {
        name: "DemoBoard",

        data() {
            return {
                routeQueryParams: this.$route.query.typeNumber,
                typeNumberQueryParameters: [],
                demoBoardItems: {},
                emptyValues: {
                    typeNumber: [],
                    description: [],
                    productDetailsLink: [],
                    dataSheetLink: [],
                    identifier: [],
                    application: [],
                    demoSignal: [],
                    demoReport: [],
                    demoReportLink: [],
                    frangeMin: [],
                    frangeMax: [],
                    pl1dB: [],
                    pl1dBdBm: [],
                    pl3dB: [],
                    pl3dBdBm: [],
                    pl4dB: [],
                    pl4dBdBm: [],
                    pl5dB: [],
                    pl5dBdBm: [],
                    plav: [],
                    plavdBdBm: [],
                    nd: [],
                },
                productFromUrl: {
                    typeNumber: ""
                },
                isDemoLoading: false,
                isDemoFetchingSuccess: false,
                isDemoFetchingFailed: false
            }
        },
        props: {
            isPublic: {
                type: Boolean
            },
        },
        mounted() {
            this.typeNumberQueryParameters = new URLSearchParams();

            if ('string' === typeof (this.routeQueryParams)) {
                //the query params will be a string if you copy-paste the url
                //parsing the typeNumber from the url query
                this.productFromUrl.typeNumber = this.routeQueryParams;

                this.typeNumberQueryParameters.append('typeNumber', this.productFromUrl.typeNumber);
            } else if ('object' === typeof (this.routeQueryParams)) {
                //the query param will be an object (array) if the user comes through router push
                this.productFromUrl.typeNumber = this.routeQueryParams;
                this.typeNumberQueryParameters.append('typeNumber', this.productFromUrl.typeNumber);
            }

            this.isDemoLoading = true;
            ParametricSearchService.demoBoardQuery(this.typeNumberQueryParameters)
                .then(({data}) => {
                this.isDemoFetchingSuccess = data.success;
                this.isDemoLoading = false;
                if(this.isDemoFetchingSuccess){
                    this.isDemoFetchingFailed = false;
                    this.demoBoardItems = data;
                }})
                .catch(() => {
                    this.isDemoLoading = false;
                    this.isDemoFetchingSuccess = false;
                    this.isDemoFetchingFailed = true;
                    this.demoBoardItems = {};
                })
        },
        computed: {
            convertedDemoBoardItems() {
                let actualProductParametrics = this.emptyValues;
                if (this.demoBoardItems) {
                    actualProductParametrics.typeNumber = [this.demoBoardItems.typeNumber];
                    actualProductParametrics.description = [this.demoBoardItems.description];
                    actualProductParametrics.productDetailsLink = [this.demoBoardItems.productDetailsLink];
                    actualProductParametrics.dataSheetLink = [this.demoBoardItems.dataSheetLink];

                    if(this.demoBoardItems.demoBoardParametrics) {
                        this.demoBoardItems.demoBoardParametrics.forEach(parametric => {
                            actualProductParametrics.identifier.push(parametric.identifier);
                            actualProductParametrics.application.push(parametric.application);
                            actualProductParametrics.demoSignal.push(parametric.demoSignal);
                            actualProductParametrics.demoReport.push(parametric.demoReport);
                            actualProductParametrics.demoReportLink.push(parametric.demoReportLink);
                            actualProductParametrics.frangeMin.push(parametric.frangeMin);
                            actualProductParametrics.frangeMax.push(parametric.frangeMax);
                            actualProductParametrics.pl1dB.push(parametric.pl1dB);
                            actualProductParametrics.pl1dBdBm.push(parametric.pl1dBdBm);
                            actualProductParametrics.pl3dB.push(parametric.pl3dB);
                            actualProductParametrics.pl3dBdBm.push(parametric.pl3dBdBm);
                            actualProductParametrics.pl4dB.push(parametric.pl4dB);
                            actualProductParametrics.pl4dBdBm.push(parametric.pl4dBdBm);
                            actualProductParametrics.pl5dB.push(parametric.pl5dB);
                            actualProductParametrics.pl5dBdBm.push(parametric.pl5dBdBm);
                            actualProductParametrics.plav.push(parametric.plav);
                            actualProductParametrics.plavdBdBm.push(parametric.plavdBdBm);
                            actualProductParametrics.nd.push(parametric.nd);
                        })
                    }
                }
                return actualProductParametrics;
            },
        },
        methods: {
         async   downloadDemoBoardExcel() {
                if (this.isDemoFetchingSuccess) {
                  await  ParametricSearchService.downloadDemoBoardExcel(this.productFromUrl.typeNumber)
                        .then(function (response) {
                            downloadFile(response, mimeTypes.xlsx);
                        })
                        .catch(error => {
                            throw new Error(error);
                        });
                }
            }
        }
    }
</script>